module.exports = __webpack_public_path__ + "img/tree.c9db943b.png";